import axios from 'axios';

import { API_BASE_URL, PAGE_SIZE } from '../../App/azure/api';
import { msalInstance } from '../../App/azure/authConfig';
import { getAccessToken } from '../../App/azure/auth';

export const fetchTourEnquiries = async (page, filters = {}) => {
    const token = await getAccessToken(msalInstance);

    const params = new URLSearchParams({
        page: page || 1,
        pageSize: PAGE_SIZE,
        ...filters
    });

    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_BASE_URL}/getAllTourEnquiries?${params.toString()}`,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
}

export const fetchNewTourEnquiriesCount = async () => {
    const token = await getAccessToken(msalInstance);

    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_BASE_URL}/getNewTourEnquiriesCount`,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
}

export const updateTourEnquiryStatus = async (id, status, notes) => {
    const token = await getAccessToken(msalInstance);

    const data = {
        id,
        status,
        notes
    };

    let config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: `${API_BASE_URL}/updateTourEnquiryStatus`,
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    };

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
}
